var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.99982 6.00015V8.66682M7.99982 11.3335H8.00648M7.0767 2.59464L1.59344 12.0657C1.2893 12.591 1.13723 12.8537 1.15971 13.0693C1.17931 13.2573 1.27783 13.4282 1.43073 13.5394C1.60604 13.6668 1.90954 13.6668 2.51656 13.6668H13.4831C14.0901 13.6668 14.3936 13.6668 14.5689 13.5394C14.7218 13.4282 14.8203 13.2573 14.8399 13.0693C14.8624 12.8537 14.7103 12.591 14.4062 12.0657L8.92294 2.59463C8.61989 2.07119 8.46837 1.80947 8.27068 1.72157C8.09824 1.64489 7.90139 1.64489 7.72895 1.72157C7.53126 1.80947 7.37974 2.07119 7.0767 2.59464Z",
    stroke: "#E02B1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.24e38c1f6e621b863babbd26996e00c9.svg";
export { ForwardRef as ReactComponent };